import { List, Map } from "immutable";

type SectionId = string;
type AssigneeId = string;
export type Users = Map<AssigneeId, List<SectionId>>;

export function getUserSectionIds(state: Users, assigneeId: AssigneeId) {
  return state.get(assigneeId);
}

export function getNumberOfUserSectionIds(
  state: Users,
  assigneeId: AssigneeId
) {
  return getUserSectionIds(state, assigneeId)!.size;
}

export function getAllSectionIds(state: Users) {
  const allSectionIds = state.reduce((acc, sectionIds) => {
    return acc.concat(sectionIds);
  }, List<SectionId>());
  return allSectionIds.toSet().toList();
}

export function getAssigneeIds(state: Users): List<AssigneeId> {
  return state.keySeq().toList();
}
